module.exports = __webpack_public_path__ + "static/media/refundSuccessful.6a6d3117.svg";